export enum CalculationChoicesBoxActionTypeEnum {
  ResetCalculation = 'resetCalculation',
}
